import React, { memo, HTMLProps, FormEvent } from 'react';
import classnames from 'classnames';
import Element from '../../element';
import styles from './input.module.scss';

interface IProps extends HTMLProps<HTMLInputElement> {
    type?: string;
    danger?: boolean;
    onChangeValue?: (value: string) => void;
    domRef?: any;
}

function Input({
    type = 'text',
    danger = false,
    onChangeValue,
    onChange,
    domRef,
    ...rest
}: IProps) {
    const handleChange = (e: FormEvent<HTMLInputElement>) => {
        onChange && onChange(e);
        onChangeValue && onChangeValue(e.currentTarget.value);
    };

    return (
        <Element className={styles['control']}>
            <Element
                renderAs="input"
                className={classnames(styles['input'], styles['is-primary'], {
                    [styles['is-danger']]: danger,
                })}
                domRef={domRef}
                type={type}
                onChange={handleChange}
                {...rest}
            />
        </Element>
    );
}

export default memo(Input);
